/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Keys_UnderlineInputs */

const en_wc_tut_keys_underline = /** @type {(inputs: Wc_Tut_Keys_UnderlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Underline`)
};

/**
* | output |
* | --- |
* | "Underline" |
*
* @param {Wc_Tut_Keys_UnderlineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_keys_underline = /** @type {((inputs?: Wc_Tut_Keys_UnderlineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Keys_UnderlineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_keys_underline(inputs)
});
export { wc_tut_keys_underline as "wc.tut.keys.underline" }